import { Grid, GridItem } from '@chakra-ui/react';
import React, { useContext, useEffect, useMemo } from 'react';
import { commonStyle } from '../../common/styles';
import { MessageInfoContext } from '../../context/MessageInfoContextProvider';

import { MdTouchApp } from 'react-icons/md';
import { WindowSizeContext } from '../../context/WindowSizeContextProvider';
import { DialogStateContext } from '../../context/DialogStateContextProvider';
import { LanguageContext } from '../../context/LanguageContextProvider';

// ヘッダー表示する最大文字数
const MAX_LENGTH_JA = 18;
const MAX_LENGTH_EN = 36;

const ERROR_MESSAGE_JA = '情報が取得できません。';
const ERROR_MESSAGE_EN = 'Failed to get information.';

const Message: React.FC = () => {
  const { info } = useContext(MessageInfoContext);
  const { openDialog } = useContext(DialogStateContext);
  const { size } = useContext(WindowSizeContext);
  const { language } = useContext(LanguageContext);

  // 英語選択　かつ　英語メッセージがある場合　のみ英語表記
  const isEnglish: boolean = useMemo(
    () => info.message_en !== '' && language === 'en',
    [info.message_en, language]
  );

  // 上限以上の文字数の場合はカット、エラー時は専用メッセージ
  const headerMessage = useMemo(() => {
    if (info.failedGetMessage) {
      return isEnglish ? ERROR_MESSAGE_EN : ERROR_MESSAGE_JA;
    } else if (isEnglish) {
      return info.message_en.length <= MAX_LENGTH_EN
        ? info.message_en
        : info.message_en.slice(0, MAX_LENGTH_EN) + '...';
    } else {
      return info.message.length <= MAX_LENGTH_JA
        ? info.message
        : info.message.slice(0, MAX_LENGTH_JA) + '...';
    }
  }, [isEnglish, info.failedGetMessage, info.message, info.message_en]);

  // 緊急時の強制ポップアップ表示
  useEffect(() => {
    if (info.isFirst === true && info.popup === true) {
      openDialog('message');
    }
  }, [info.isFirst, info.popup, openDialog]);

  return (
    <Grid
      w='100%'
      h='100%'
      gridTemplateColumns='90% 10%'
      bgColor={info.bgColor}
      cursor='pointer'
      onClick={() => {
        openDialog('message');
      }}
    >
      <GridItem
        gridColumn={1}
        w='100%'
        h='100%'
        paddingLeft='2%'
        fontSize='14px'
        color={info.color}
        sx={{ ...commonStyle.center, justifyContent: 'flex-start' }}
      >
        {!info.noOperation && headerMessage}
      </GridItem>
      <GridItem gridColumn={2} w='100%' h='100%' sx={{ ...commonStyle.center }}>
        <MdTouchApp color={info.iconColor} size={size.h / 25}></MdTouchApp>
      </GridItem>
    </Grid>
  );
};

export default React.memo(Message);
